<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputGradeCode" });
import Chip from "../../../../elements/chip/Chip.svelte";
import { t } from "svelte-i18n";
export let code;
export let mode = "full";
export let isActive = false;
</script>

{#if mode === 'compact'}
    <span class = { isActive ? '' : 's8-off' }>
        <Chip>
            { $t(`resource.auction.properties.grade.code.options_compact.${ code }`) }
        </Chip>
    </span>
{:else}
    { $t(`resource.auction.properties.grade.code.options.${ code }`) }
{/if}

<style>
    span.s8-off {
        opacity: 0.1;
    }</style>